import React, { useState } from "react";
import PropTypes from "prop-types";

const FormTagsInput = ({
  field,
  value = [],
  handleChange,
  error = null,
  className = "",
  ErrIsScroll = false,
}) => {
  const [inputValue, setInputValue] = useState("");

  const values = React.useMemo(() => {
    if (Array.isArray(value)) return value;

    if (typeof value === "string") {
      return value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    }

    return [];
  }, [value]);

  const updateValue = (list) => {
    handleChange({
      target: {
        name: field.name,
        value: list,
      },
    });
  };

  const addTag = () => {
    const val = inputValue.trim().toUpperCase();

    if (!val) return;

    if (!values.includes(val)) {
      updateValue([...values, val]);
    }

    setInputValue("");
  };

  const removeTag = (index) => {
    updateValue(values.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (["Enter", ",", "Tab"].includes(e.key)) {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div className={`${className} ${field.fieldSize || "col-12"}`}>
      {!field.lableHide && (
        field.label ? (
          <label className="form-label text-muted">
            {field.label}{" "}
            {field.required && (
              <span className="text-danger small">*</span>
            )}
          </label>
        ) : (
          <label className="mt-sm-4"></label>
        )
      )}

      <div
        className={`form-control p-2 ${error ? "border-danger" : ""
          }`}
        style={{ minHeight: "42px" }}
      >
        <div className="d-flex flex-wrap gap-2 align-items-center">

          {values.map((item, index) => (
            <span
              key={index}
              className="badge bg-primary d-flex align-items-center"
            >
              {item}
              <button
                type="button"
                className="btn-close btn-close-white ms-2"
                style={{ fontSize: "8px" }}
                onClick={() => removeTag(index)}
              />
            </span>
          ))}

          <input
            type="text"
            className="border-0 flex-grow-1"
            style={{
              minWidth: "120px",
              outline: "none",
              boxShadow: "none",
            }}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={addTag}
            placeholder={field.placeholder || ""}
            disabled={field.disabled}
            readOnly={field.readOnly}
          />
        </div>
      </div>

      {error && ErrIsScroll && (
        <span
          className="text-danger overflow-y-scroll w-100 d-block"
          style={{ height: "30px" }}
        >
          {error}
        </span>
      )}

      {error && !ErrIsScroll && (
        <span className="text-danger">{error}</span>
      )}
    </div>
  );
};

FormTagsInput.propTypes = {
  field: PropTypes.object,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  handleChange: PropTypes.func,
  error: PropTypes.any,
  className: PropTypes.string,
  ErrIsScroll: PropTypes.bool,
};

export default FormTagsInput;